import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './shared/language/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  title = 'MDC';

  constructor(private translateService: TranslateService, private router: Router, private languageService: LanguageService) {
    this.translateService.setDefaultLang('pt');
    this.translateService.use(localStorage.getItem('lang') || 'pt')
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.languageService.languageDropdownOpen = false;
      }
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateBodyClass(event.urlAfterRedirects);
      }
    });
  }
  
  showLayout(): boolean {
    return this.router.url !== '/login';
  }

  private updateBodyClass(url: string) {
    if (url.startsWith('/login')) {
      document.body.className = 'nk-body bg-white npc-general pg-auth';
    } else {
      document.body.className = 'nk-body npc-invest bg-lighter';
    }
  }
}
